export const ERROR_MESSAGES = {
  en: {
    filesExceedLimit: "Selected files exceed the 5MB total size limit",
    addingFilesExceedLimit: "Adding these files would exceed the 5MB total size limit",
    connectionError: "Connection error occurred. Please try again.",
    invalidFileType: "Invalid file type. Only images, documents, and PDFs are allowed.",
    invalidFileTypeSingle: "Invalid file type. Only images, documents, and PDFs are allowed.",
    chatAlreadyAssigned: "Chat already assigned to another agent"
  },
  tr: {
    filesExceedLimit: "Seçilen dosyalar 5MB toplam boyut sınırını aşıyor",
    addingFilesExceedLimit: "Bu dosyaları eklemek 5MB toplam boyut sınırını aşacak",
    connectionError: "Bağlantı hatası oluştu. Lütfen tekrar deneyin.",
    invalidFileType: "Geçersiz dosya türü. Sadece resimler, belgeler ve PDF'ler kabul edilir.",
    invalidFileTypeSingle: "Geçersiz dosya türü. Sadece resimler, belgeler ve PDF'ler kabul edilir.",
    chatAlreadyAssigned: "Sohbet başka bir agente atandı"
  },
  es: {
    filesExceedLimit: "Los archivos seleccionados superan el límite de tamaño total de 5MB",
    addingFilesExceedLimit: "Agregar estos archivos superaría el límite de tamaño total de 5MB",
    connectionError: "Ocurrió un error de conexión. Por favor, inténtalo de nuevo.",
    invalidFileType: "Tipo de archivo inválido. Solo se permiten imágenes, documentos y PDFs.",
    invalidFileTypeSingle: "Tipo de archivo inválido. Solo se permiten imágenes, documentos y PDFs.",
    chatAlreadyAssigned: "El chat ya ha sido asignado a otro agente"
  }
} as const;

export type SupportedLanguage = keyof typeof ERROR_MESSAGES;
export type ErrorMessageKey = keyof typeof ERROR_MESSAGES.en;

// Allowed file types
export const ALLOWED_FILE_TYPES = {
  // Images (input_image)
  'image/jpeg': '.jpg, .jpeg',
  'image/png': '.png',
  'image/gif': '.gif',
  'image/webp': '.webp',

  // Documents (file - ONLY PDF allowed)
  'application/pdf': '.pdf',
} as const;

export const ALLOWED_FILE_EXTENSIONS = [
  // Images (input_image)
  '.jpg', '.jpeg', '.png', '.gif', '.webp',

  // Documents (file - ONLY PDF allowed)
  '.pdf',
] as const;
